<template>
    <Layout>

        <section class="section">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Registration Confirmation</h2>

                             <p>
                                 You have successfully registered for {{conference.name}}.
                                 You will receive a confirmation email shortly including your registration information.
                            </p>

                            <p>
                                You can edit your registration details through the Application form that will be shared with you shortly with your username & password or if you need any further assistance,
                                you may contact us on <a style="text-decoration:underline" href="mailto:VirtualConference@EFGHERMES.com">{{conference.name.toUpperCase()}} email</a>
                            </p>

                           <!--  <p><b><a href="#">Please click here</b></a> if you would like to book your hotel room now at the <b>Atlantis, The
                                    Palm</b> Hotel with the benefit of the EFG Hermes group rate. Alternatively, you may regiser by following the
                                link in the confirmation email you will shortly receive.</p> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

    </Layout>
</template>

<script>
import Layout from '@/components/layouts/Layout.vue'
import { required } from 'vuelidate/lib/validators'
import Api from '@/Api'

export default {
    name: 'Thank',
    components: {Layout},
    data() {
        return {
            conference: JSON.parse(localStorage.getItem('conference'))
        };
    },
    validations: {

    },
    methods: {

    }
};
</script>
